<template>
  <div id="">
      <v-app >
        <v-main>
          <UserNavbar/>
          <login/>
        </v-main>
      </v-app>
  </div>
</template>

<script>
import UserNavbar from '@/components/PublicNavbar'
import login from '../components/LoginComponent'
export default {
  props: {
    source: String
  },
  components: {
    UserNavbar,
    login
  }
}
</script>
